export default __webpack_public_path__ + "static/media/Roboto-ThinItalic.026cbce1.ttf";